// Create a user schema to validate the user data.
import * as Yup from 'yup';
const usersSchema = {
  createCustomer: Yup.object({
    firstname: Yup.string().required('Le prénom est requis'),
    lastname: Yup.string().required('Le nom est requis'),
    email: Yup.string().email('L\'email est invalide'),
    phone: Yup.string(),
    phonePrefix: Yup.string(),
    birthdate: Yup.date().nullable(),
    contactOrigin: Yup.string(),
    address: Yup.object({
      street: Yup.string()
        .test('address-required', 'La rue est requise', function (value) {
          const { city, postcode } = this.parent;
          return !(city || postcode) || (value && value.length > 0);
        }),
      city: Yup.string()
        .test('city-required', 'La ville est requise', function (value) {
          const { street, postcode } = this.parent;
          return !(street || postcode) || (value && value.length > 0);
        }),
      state: Yup.string().optional().nullable(),
      postcode: Yup.string()
        .test('postcode-required', 'Le code postal est requis', function (value) {
          const { street, city } = this.parent;
          return !(street || city) || (value && value.length > 0);
        }),
      isoCountry: Yup.string()
        .test('isoCountry-required', 'Le pays est requis', function (value) {
          const { street, city, postcode } = this.parent;
          // Si on a une adresse (street, city ou postcode), le code pays est requis
          return !(street || city || postcode) || (value && value.length > 0);
        }),
      legalFirstname: Yup.string().optional().nullable(),
      legalLastname: Yup.string().optional().nullable(),
    }),
    isCustomerTherapist: Yup.boolean().default(false),
  })
};

export default usersSchema;
